import { CRS } from 'leaflet';
/**
 * @function getCrs - систему координат узнаём
 * @param provider - текущий провайдер карт
 * @return CRS
 */
export function getCrs(provider) {
    if (provider === 'yandex') {
        return CRS.EPSG3395;
    }
    return CRS.EPSG3857;
}
